import { Input, InputRef } from "antd";
import { observer } from "mobx-react-lite";
import * as React from "react";

import { MdmCardFormStore } from "../MdmCardFormStore";
import { FnFocus, FormField } from "../types/MdmCardFormTypes";
import { ZCompInput } from "../types/metaComponent";
import { FieldBox } from "./FieldBox";
import { focusCtrl } from "./focusCtrl";

interface PropsCardInput {
  form: MdmCardFormStore;
  field: FormField;
  component: ZCompInput;
  focusBk: (onFocus: FnFocus) => void;
}

export const CardInput: React.FC<PropsCardInput> = observer((props) => {
  const { field, form, component, focusBk } = props;
  const { data, path } = field;
  const text: string = data?.type === "string" ? data.value : "";
  const addonAfter =
    component.addonAfter && form.evaluateText(component.addonAfter);
  const error = form.errors[field.path];
  const iref = React.useRef<InputRef>(null);
  React.useEffect(() => focusCtrl(iref.current, focusBk), [iref.current]);
  return (
    <FieldBox field={field} form={form}>
      <Input
        ref={iref}
        style={{ width: "100%" }}
        value={text}
        disabled={form.isItemDisabled(field)}
        maxLength={component.maxLength ?? undefined}
        addonAfter={addonAfter}
        status={error ? "error" : undefined}
        allowClear
        onChange={(e) => {
          const { value } = e.currentTarget;
          field.setData({ type: "string", value, name: field.meta.name });
          form.onChange(path);
        }}
      />
    </FieldBox>
  );
});
